// Business-related constants and external links
export const EXTERNAL_LINKS = {
  APPINES_WEBSITE: 'https://www.appines.fr',
  APPINES_CAREER: 'https://appines.app.link/simulateur-ngap-kine',
  APPINES_CONTACT: 'https://www.appines.fr/contact',
  APPINES_ABOUT: 'https://www.appines.fr/a-propos'
} as const;

// App'Ines brand colors
export const APPINES_COLORS = {
  MAIN: '#25BBA5',
  DARK: '#18413B',
  DARKER: '#18413B',
  WHITE: '#FFFFFF',
  LIGHT: '#F8F9FA'
} as const;

// App'Ines messaging
export const APPINES_MESSAGING = {
  TAGLINE: 'Si on te trouve une cotation, on doit bien pouvoir te trouver un rempa',
  CTA_TEXT: 'Trouver un rempla',
  CTA_EMOJI: '👉'
} as const;
